import styled from "styled-components";

const ShoppListIngrContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
   @media (max-width: 414px) {
       padding: 2px 0;
`;

export default ShoppListIngrContainer;
